<template>
	<div class="cartcontrol">
		<!-- 减少 -->
		<transition name="move">
			<div class="cart-decrease" v-show="food.count>0" @click="decreaseCart" >
				<span class="inner icon-remove_circle_outline"></span>
			</div>
		</transition>	
		<!-- 商品数量： -->
    <span class="cart-count" 
          v-show="food.count>0" 
           @click="showInput">
      {{ food.count }}
    </span>
		<!-- 增加： -->
		<div class="cart-add icon-add_circle" @click="addCart"></div>
		
		<!-- 弹窗组件 -->
     
	</div>
</template>

<script>
import Vue from 'vue';
export default {
  props:{
  	food:{
  		type:Object
  	}
  },
  data () {
    return {
      step: this.food.dancicaigou,
      showModal: false,
      tempValue: 0
    }
  },
  methods:{
    showInput() {
	console.log('open');
      // 触发父组件打开弹窗
      this.$emit('show-input', this.food);
	    this.$emit('shopcartshow-input', this.food);
    },
    showInputModal() {
      this.showModal = true;
      this.tempValue = this.food.count;
      this.$emit('lock-scroll'); // 通知父组件锁定滚动
      
      this.$nextTick(() => {
        this.$refs.modalInput.focus();
        this.$refs.modalInput.select();
      });
    },
    closeModal() {
      this.showModal = false;
      this.$emit('unlock-scroll'); // 通知父组件解锁滚动
    },
    confirmInput() {
      const newValue = Number(this.tempValue);
      if (isNaN(newValue) || newValue < 0) {
        alert('请输入有效的数量');
        return;
      }
      if (newValue > 0) {
        this.$set(this.food, 'count', newValue);
      } else {
        Vue.delete(this.food, 'count');
      }
      this.closeModal();
    },
  	addCart(){
      if(!this.food.count){
        Vue.set(this.food,'count',Number(this.step));
      }else{
        this.$set(this.food, 'count', Number(this.food.count) + Number(this.step));
      }
  		this.$emit('cart-add',event.target);
  	},
  	decreaseCart(){
  		if(this.food.count){
        this.$set(this.food, 'count', Number(this.food.count) - Number(this.step));
  		}
  	}
  }
}
</script>

<style lang="less" scoped>
@import "../../common/less/index.less";
.cartcontrol{
	font-size: 0;
	.cart-decrease{
		display:inline-block;
		padding:6px;
		transition:all 0.4s linear;
		transform:translate3D(0,0,0);
	    .inner{
	    	display:inline-block;
	    	line-height:24px;
			font-size: 24px;
			color:rgba(0,160,220);
			transform:rotate(0);
			transition:all 0.4s linear;
	    }
		&.move-enter,&.move-leave-to{
			opacity:0;
			transform:translate3D(24px,0,0);
			.inner{
				transform:rotate(180deg);
			}
		}	    
	}
	.cart-count{
		display:inline-block;
		font-size: 10px;
		vertical-align:top;
		width:22px;
		padding-top: 6px;
		color:#93999f;
		line-height:24px;
		text-align: center;
	}
	.cart-add{
		display:inline-block;
		padding:6px;
		line-height:24px;
		font-size: 24px;
		color:rgba(0,160,220)
	}
}
.modal {
position: fixed; /* 关键：脱离父容器限制 */
  top: 0;
  left: 0;
  width: 100vw; /* 覆盖视口 */
  height: 100vh;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  z-index: 2147483647; /* 最高层级 */
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
 position: relative; /* 避免受父元素影响 */
  width: 80%;
  max-width: 400px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  
  input {
    width: 100%;
    padding: 12px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    
    &:focus {
      border-color: rgba(0, 160, 220);
      outline: none;
    }
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 20px;
  
  button {
    padding: 10px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
	line-height:20px;
    &:first-child {
      background: #f0f0f0;
      
      &:hover {
        background: #e0e0e0;
      }
    }
    
    &:last-child {
      background: rgba(0, 160, 220);
      color: white;
      
      &:hover {
        background: rgba(0, 140, 200);
      }
    }
  }
}
</style>